import React from "react";


export default function Icon(props) {
  return (
    <i
      className={`icon ${props.icon} ${props.className}`}
      onClick={props.onClick}
    >
    </i>
  )
}


/*

Usage:

<Icon icon="" />

- icon: Figma Icon Name in format "icon-name"

*/
